
export function btoaUTF8(data) {
    const utf8Data = new TextEncoder().encode(data);
    let binaryString = "";
    for (let i = 0; i < utf8Data.length; i++) {
        binaryString += String.fromCharCode(utf8Data[i]);
    }
    return btoa(binaryString);
}

export function atobUTF8(data) {
    const decodedData = atob(data);
    const utf8data = new Uint8Array(decodedData.length);
    const decoder = new TextDecoder("utf-8");
    for (let i = 0; i < decodedData.length; i++) {
        utf8data[i] = decodedData.charCodeAt(i);
    }
    return decoder.decode(utf8data);
}
